<template>
  <div
    class="header-placeholder font-weight-light"
    :style="`
      width: ${width};
      height: ${height};
      z-index: ${z_index};
      left: ${sticky_left};
      border-color: ${border_color?`${border_color}`:'var(--header_border_color)'};
      background-color: ${background_color?`${background_color}`:'var(--v-color-4-base)'};
      ${max_height?`max-height: ${max_height};`:''}
      ${border_width?`border-width: ${border_width};`:''}
      ${min_width?`min-width: ${min_width};`:''}
      `"
    >
    <slot/>
    <div class="header-placeholder-right-middle">
      <slot name="right-middle"/>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'HeaderPlaceholder',
    props: [
      'width',
      'height',
      'z_index',
      'sticky_left',
      'max_height',
      'border_color',
      'background_color',
      'border_width',
      'min_width'
    ],
    data: () => ({
    }),
  }
</script>
<style>
  .header-placeholder {
    position: sticky;
    position: -webkit-sticky;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    border-style: solid;
    border-width: 1px 1px 1px 1px;
    padding: calc(5px * var(--taktplan_zoom));
    will-change: width;
    transform: translateZ(0);
    flex-shrink: 0;
  }
  .header-placeholder-right-middle {
    position: absolute;
    top: 50%;
    right: 0px;
  }
</style>
